import { helpers } from '@marketplace/plugins/global.js'

export const state = () => ({
    canSeeOcPlus: false,
    hasOcPlus: false,
})

export const getters = {
    canSeeOcPlus: (rootGetters) => {
        return (
            helpers.isInCoreCountry &&
            helpers.isRetailerAccount &&
            helpers.isLoggedIn &&
            !rootGetters['global/isAssociationRetailer']
        )
    },
    hasOcPlus: (state) => {
        return state.hasOcPlus
    },
}

export const mutations = {
    updateOcPlusState(state, payload) {
        state.hasOcPlus = payload
    },
}
